import { SolidifyableData } from "@lib/titan2/dist/api/core/data/SolidifyableData";
import { SlingoConstants } from "../enum/SlingoConstants";
/*
 * PrizeConfigData.ts
 */
export class PrizeConfigData extends SolidifyableData {
    constructor(data) {
        super(data);
        this.solidify();
    }
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.id = this.data.getString(SlingoConstants.PROPERTY_ID);
            this.pattern = this.data.getNumber(SlingoConstants.PROPERTY_PATTERN);
            this.spins = this.data.getNumber(SlingoConstants.PROPERTY_SPINS);
            this.multiplier = this.data.getNumber(SlingoConstants.PROPERTY_MULTIPLIER);
            this.basePayout = this.data.getNumber(SlingoConstants.PROPERTY_BASE_PAYOUT);
        }
    }
    getId() {
        return this.id;
    }
    getPattern() {
        return this.pattern;
    }
    getSpins() {
        return this.spins;
    }
    getMultiplier() {
        return this.multiplier;
    }
    getBasePayout() {
        return this.basePayout;
    }
}
//# sourceMappingURL=PrizeConfigData.js.map